import { useSWRFetcher } from "./useSWRFetcher";
import { environment } from "../config/environment";
import useSWRMutation from "swr/mutation";
import { ChatEmailResponse, ChatEmailRequest } from "@attelas/shared";

export const useChatEmail = () => {
  const fetcher = useSWRFetcher();

  const { trigger, isMutating, error } = useSWRMutation(
    `${environment.apiUrl}/api/chats/emails`,
    (url: string, { arg }: { arg: ChatEmailRequest }) =>
      fetcher<ChatEmailResponse>(url, {
        method: "POST",
        body: JSON.stringify(arg),
      })
  );

  return {
    chatEmail: trigger,
    isLoading: isMutating,
    isError: !!error,
  };
};
